import React from "react";
import { Drawer } from "rsuite";

import "./TroubleReportsTabStyle.css";
//import TroubleReportsController from "./../../misc/TroubleReportsController";

const TroubleReports = ({ troubleReportData, openVar, openMethod }) => {
  return (
    <>
      <Drawer
        placement={"bottom"}
        open={openVar}
        onClose={() => openMethod(false)}
        size={"full"}
        backdrop={true}
      >
        <Drawer.Header className="text-gradient-primary">
          Störungsmeldungen
        </Drawer.Header>
        <Drawer.Body>
          <div className="DrawerBody">
            {/*
              <TroubleReportsController troubleReportData={troubleReportData} />
            */}

            <p>
              <b>Diese Funktion ist derzeit leider nicht implementiert.</b>
            </p>
          </div>
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default TroubleReports;
